export enum LogoSize {
  MID = 'mid',
  SMALL = 'small',
  ICON = 'icon',
  MINI = 'mini',
}

export enum BackgroundColor {
  DARK = 'dark',
  LIGHT = 'light',
}

export type BackgroundColourType = 'dark' | 'light';
